module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    attrs: {
      "id": "img-upload"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.panel),
      expression: "panel"
    }],
    staticClass: "img-container"
  }, [_c('div', [_c('img', {
    attrs: {
      "id": "image",
      "src": _vm.url,
      "alt": "Picture"
    }
  })]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "button",
      "id": "img-button-cancel"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "button",
      "id": "img-button-submit"
    },
    on: {
      "click": _vm.crop
    }
  }, [_vm._v("确定")])]), _vm._v(" "), _c('div', {
    staticClass: "picture"
  }, [_c('div', {
    staticClass: "user-image text-xs-center mb-3"
  }, [_c('Upload', {
    ref: "upload",
    attrs: {
      "multiple": "",
      "name": "upfile",
      "max-size": 1024,
      "format": ['jpg', 'jpeg', 'png'],
      "action": _vm.uploadUrl,
      "headers": _vm.headers,
      "with-credentials": true,
      "show-upload-list": false,
      "on-success": _vm.uploadSuccess,
      "before-upload": _vm.beforeUpload
    }
  }, [_c('img', {
    staticClass: "img-responsive rounded-circle",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "alt": "",
      "title": _vm.$t('userSetting.uploadImgTitle'),
      "src": _vm.url
    }
  })])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d163cccc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ImageUpload.vue
// module id = 469
// module chunks = 0